import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-value-added-banner',
    templateUrl: './value-added-banner.component.html',
    styleUrls: ['./value-added-banner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ValueAddedBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
